import React, { useRef, useEffect } from "react";
import Map, { NavigationControl } from "react-map-gl";

const MapLayer = ({ onMapLoad, showReport, initialView }) => {
  const mapRef = useRef(null);

  const handleMapLoad = (event) => {
    // MapboxGLのmapインスタンスを親に渡す
    if (onMapLoad) {
      onMapLoad(event.target);
    }
  };

  if (showReport){
    return <></>
  } else {
    return (
    <Map
      ref={mapRef}
      initialViewState={{
        latitude: initialView.lat,  
        longitude: initialView.lng, 
        zoom: initialView.zoomLv,
      }}
      style={{ width: "100%", height: "100vh" }}
      mapStyle="mapbox://styles/sota0213/cm5w8rukm00pq01rae57zbhv3"
      // mapStyle="mapbox://styles/mapbox/light-v11"
      //mapStyle="mapbox://styles/sota0213/clqbddr4p003p01r61jx24eqi"
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
      onLoad={handleMapLoad}
    >
      <NavigationControl position="top-left" />
    </Map>
    );
  }
};

export default MapLayer;
